import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=96677b70"
import script from "./Contratos.vue?vue&type=script&lang=ts"
export * from "./Contratos.vue?vue&type=script&lang=ts"
import style0 from "./Contratos.vue?vue&type=style&index=0&id=96677b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports